export default {"src":"/_next/static/media/Vector-radial-circles2.05c16bbc.svg","height":205,"width":187,"blurWidth":0,"blurHeight":0};